import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CrudModeEnum } from '../../../../../../core/base/enum/crud-mode.enum';
import { Observable } from 'rxjs';
import { UserProfileModel } from '../../../../../../core/models/user-profile.model';
import icClose from '@iconify/icons-ic/twotone-close';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UserProfileService } from '../../../user-profile/user-profile.service';
import { EstablishmentService } from '../../establishment.service';
import { ActivatedRoute } from '@angular/router';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';
import { map } from 'rxjs/operators';
import { AffectationModel } from '../../../../../../core/models/affectation.model';
import { ContactTypeModel } from '../../../../../../core/models/contact-type.model';
import { BaseContactType } from '../../../../../../core/enums/contact-type.enum';
import { Typology } from '../../../../../../core/enums/typology.enum';
import { ContactTypeService } from '../../../../settings/contact-type/contact-type.service';

@Component({
  selector: 'vex-establishment-contact-affectation',
  templateUrl: './establishment-contact-affectation.component.html',
  styleUrls: ['./establishment-contact-affectation.component.scss'],
})
export class EstablishmentContactAffectationComponent implements OnInit {
  form: UntypedFormGroup;
  mode: CrudModeEnum = CrudModeEnum.Create;

  contacts$: Observable<Array<UserProfileModel>>;
  responsables$: Observable<any>;

  contactFilters: any = {};
  responsableFilters: any = {};
  establishmentId: string;
  canReadMode = false;
  icClose = icClose;
  contactTypes: ContactTypeModel[] = [];
  loading = false;
  issupportEstablishment = false;
  defaults: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<EstablishmentContactAffectationComponent>,
    public userProfileService: UserProfileService,
    private service: EstablishmentService,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackbarService,
    private contactTypeService: ContactTypeService,
  ) {}

  ngOnInit(): void {
    this.initData();
    this.contactChange();
    this.initForm();
    this.initValueChanges();
  }

  initData() {
    this.mode = this.data.mode;
    this.defaults = this.data.defaults;
    this.establishmentId = this.data.defaults._id;
    this.issupportEstablishment = !!this.defaults.internSupplier;
    // Le filtre Predik s'applique automatiquement côté backend
    this.contactFilters = {
      excludeEstablishmentIds: [this.establishmentId],
    };

    this.contactTypeService.findAll().subscribe(x => {
      this.contactTypes = [...x.data, ...BaseContactType]
        .filter(x => x.typology === Typology.supplier)
        .filter((item, index, self) => self.findIndex(t => t._id === item._id) === index);

      if (this.isUpdateMode()) {
        const a = [];
        this.defaults.contactTypes.forEach(x => {
          const ct = this.contactTypes.findIndex(y => y._id === x._id);
          if (ct !== -1) {
            a.push(this.contactTypes[ct]);
          }
        });
        this.form.controls.contactTypes.setValue(a);
      }
    });

    this.responsableFilters = {
      excludedIds: [],
      establishment: this.establishmentId,
      isPredik: false,
    };
  }

  initForm() {
    this.form = new UntypedFormGroup({
      _id: new UntypedFormControl(this.defaults?._id),
      contact: new UntypedFormControl(null, Validators.required),
      responsable: new UntypedFormControl(null),
    });

    if (this.issupportEstablishment) {
      this.form.addControl('contactTypes', new UntypedFormControl(this.defaults?.contactTypes || [], Validators.required));
    }

    this.form.controls.responsable.disable();
  }

  initValueChanges() {
    this.form.controls.contact.valueChanges.subscribe(value => {
      if (value?._id) {
        this.form.controls.responsable.reset();
        this.form.controls.responsable.enable();

        this.responsableFilters.excludedIds = [value._id];

        this.responsableChange();
      } else {
        this.responsableFilters.excludedIds = [];
        this.form.controls.responsable.reset();
        this.form.controls.responsable.disable();
      }
    });
  }

  createItem() {
    if (this.form.valid) {
      this.loading = true;
      const affectation: AffectationModel = {
        establishment: this.defaults,
        responsable: this.form.controls.responsable.value,
      };

      if (this.issupportEstablishment) {
        affectation.contactTypes = this.form.controls.contactTypes.value;
      }

      this.userProfileService.addAffectation(this.form.controls.contact.value._id, affectation).subscribe(
        res => {
          this.dialogRef.close(res);
        },
        error => {
          console.log(error);
          this.loading = false;
        },
      );
    }
  }

  close() {
    this.dialogRef.close();
  }

  save() {}

  isCreateMode() {
    return this.mode === CrudModeEnum.Create;
  }

  isUpdateMode() {
    return this.mode === CrudModeEnum.Update;
  }

  isDeleteMode(): boolean {
    return this.mode === CrudModeEnum.Delete;
  }

  contactChange(state: any = '') {
    this.contacts$ = this.userProfileService.findAll(null, null, 'firstName', 'asc', state, this.contactFilters).pipe(
      map(x => {
        return x.data;
      }),
    );
  }

  responsableChange(search: any = '') {
    this.responsables$ = this.userProfileService
      .findAll(null, null, 'firstName', 'asc', search, this.responsableFilters)
      .pipe(map(x => x.data));
  }
}
